import React from "react";
import { IMAGE_BASE_URI } from "../../Constants";
import "./About.scss";

const About = () => {
  return (
    <section className="card full-page col-start" id="about">
      <h1>What's in the box?</h1>
      {/* <img src={`${IMAGE_BASE_URI}Advent-Box.jpg`} alt="" /> */}

      <p>
        The Kritikal Miss Advent(ure) Kalendar is a beautiful, handcrafted
        25-day calendar full of klikky-klakky dice to build up your hoard.
      </p>
      <p>
        Each day, you’ll get a random acrylic die of a different type. By
        Christmas day, your dice tray will have 3 full sets of dice and 3 bonus
        D20s for those days when your luck is down and you need to switch it up.
      </p>
      <img src={`${IMAGE_BASE_URI}Advent-Box-w-Dice.jpg`} alt="" />
      <p>
        The Kalendar includes access to our exclusive online adventure where
        you’ll complete a small part of the story each day as we ramp up to
        Christmas and a Christmas dice bag to keep your new treasures safe.
      </p>
      <p>Get yours now</p>
      <h2>R550</h2>
      <p className="disclaimer">Shipping not included</p>
    </section>
  );
};

export default About;
